export const ORIGIN_ENTITIES = {
  OCCUPATION_ENTITY: 'occupations',
  SPECIALTY_ENTITY: 'educational_specialties',
  OCCUPATION_ABR: 'OCC',
  SPECIALTY_ABR: 'ESP',
}
